import { getQueryParams } from '../../components/helpers';
import conf from '../../conf';
import { toggleFeature } from '../../store/features';
import fetch from '../fetch';

import type { Dispatch } from '@avalara/types/actions';

export const configureFeatures = (search: string) => async (dispatch: Dispatch) => {
  const response = await fetch(dispatch, { showLoadingWheel: false })<Record<string, boolean>>(
    `${conf.API_URL}/api/features`,
  );

  if (response.ok) {
    for (const feature of Object.keys(response.value)) {
      dispatch(toggleFeature({ feature, showFeature: response.value[feature] }));
    }
  }

  const queryParams = getQueryParams(search);

  for (const feature of Object.keys(queryParams)) {
    const featureValue = queryParams[feature];
    if (typeof featureValue === 'string') {
      const showFeature = featureValue.toUpperCase() === 'TRUE';
      dispatch(toggleFeature({ feature, showFeature }));
    } else {
      dispatch(toggleFeature({ feature, showFeature: !!featureValue }));
    }
  }
};
